import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const Gift = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)" fill={color}>
      <Path d="M14.2 2.16c-.9 0-1.68.43-2.2 1.08-.51-.65-1.3-1.08-2.2-1.08-1.39 0-2.52 1.13-2.52 2.52C7.28 5.96 8.32 7 9.6 7h4.8c1.28 0 2.32-1.04 2.32-2.32 0-1.39-1.13-2.52-2.52-2.52ZM11.11 5.5h-1.5c-.45 0-.82-.37-.82-.82 0-.56.46-1.02 1.02-1.02.72 0 1.3.58 1.3 1.3v.54Zm3.3 0h-1.5v-.53c0-.72.58-1.3 1.3-1.3.56 0 1.02.46 1.02 1.02 0 .45-.37.82-.82.82V5.5Z" />
      <Path d="M19.04 5.7H4.96C3.88 5.7 3 6.58 3 7.66v3.13c0 .32.26.58.58.58h.76v7.05a2.57 2.57 0 0 0 2.57 2.57h10.17a2.57 2.57 0 0 0 2.57-2.57v-7.05h.76c.32 0 .58-.26.58-.58V7.66c0-1.08-.88-1.96-1.96-1.96h.01Zm.36 1.96v2.11h-4.75V7.3h4.39c.2 0 .36.16.36.36Zm-8.57 11.62v-7.9h2.32v7.9h-2.32ZM13.15 7.3v2.47h-2.32V7.3h2.32Zm-8.55.36c0-.2.16-.36.36-.36h4.37v2.47H4.6V7.66Zm1.34 10.77v-7.04h3.39v8.02H6.92a.97.97 0 0 1-.97-.97l-.01-.01Zm12.11 0c0 .54-.44.97-.97.97h-2.43v-8.02h3.4v7.05Z" />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default Gift
